

const PrimaryButton = ({children, props, onClick, icon}) => {
    return (
        <button {...props} onClick={onClick} className="text-white bg-blue-700 hover:bg-blue-800 p-2 font-medium rounded-lg">
             {children}
        </button>
    );
}

export default PrimaryButton